/**
 * SORT the entities in the pair, ensuring that the pair is always the same
 * @param {Object} transaction
 * @returns {Array<String>} Array of the 2 IDs sorted alphabetically
 */
export function makeEntityPair (transaction) {
  const entitiesPair = identifyTransactionEntityIds(transaction).sort()
  return entitiesPair
}

export function makeEntityPairId (transaction) {
  const entitiesPairId = makeEntityPair(transaction).join(' <> ')
  return entitiesPairId
}

/**
 * NOT sorted: allows to identity the impacted entities
 * @param {*} transaction
 * @returns
 */
export function identifyTransactionEntityIds (transaction) {
  const entityIds = [
    transaction.chart_of_account_accounting_organisation_id || transaction.accounting_organisation_id,
    transaction.intercompany_entity_id
  ]
  return entityIds
}
